import { createLabeledMessages } from '../../../messageUtils';
const confirm = {
    formMessage: 'Chystáte se opustit stránku s rozpracovaným formulářem. Po stisku tlačítka "$t(confirm:continue)" dojde k opuštění formuláře a vyplněné údaje budou ztraceny.',
    formTitle: 'Rozpracovaný formulář',
    leaveTitle: 'Chcete opustit stránku?',
    title: 'Jste si jistý/á?',
    continue: 'Pokračovat',
    cancel: 'Zrušit',
    doYouWantToLeave: 'Opravdu chcete opustit stránku?',
    changesWontBeSaved: 'Zadané údaje a provedené změny nebudou uloženy.',
    leaveThePage: 'Opustit stránku',
    stayOnThePage: 'Zůstat na stránce'
};
export default Object.assign({}, confirm, createLabeledMessages(confirm));
